module.exports = __webpack_public_path__ + "img/pricing.5a5475dd.jpg";